import React from 'react';
import Vegeterian from '../Components/Vegeterian';
import Additional from '../Components/Additional';

const Menu = () => {
  const menuItems = [
    {
      id: 1,
      name: 'Doro Wot || Chicken Stew',
      description: 'Tender chicken gently simmered in niter kibbe herbed butter, berbere sauce & onions..',
      image: '/doro.jpeg', // Replace with the actual image URL
    },
    {
      id: 2,
      name: 'Gomen Besiga || Collard Greens (Beef or Lam) ',
      description: 'A stewed mixture of Greens and (Beef or Lam) .',
      
      image: '/Gomen.jpeg', // Replace with the actual image URL
    },
    {
        id: 3,
        name: 'Yebeg Alcha Fitfit || Lam Alcha Stew ',
        description: 'Tender lamb cooked in niter kibbe herbed butter with onions, garlic, and jalapeno peppers.',
       
        image: '/kikil.jpeg', // Replace with the actual image URL
      },
      {
        id: 4,
        name: 'Kitfo || Raw Lean Beef ',
        description: 'kitfo is a rich and flavorful dish made with minced raw lean beef, spices (the classic Ethiopian spice blend known as mitmita), and an herb-infused clarified butter known as niter kibbeh.',
        price: '$10.99',
        image: '/kitfo.jpeg', // Replace with the actual image URL
      },
      {
        id: 5,
        name: 'Tibs || Stir-Fried Beef ',
        description: 'Tibs is a meat dish cut into small cubes and sautéed in a pan with niter kibbeh (clarified butter), vegetables, herbs, garlic, ginger and berbere spice, creating a sauce rich and full of flavor.',
        price: '$10.99',
        image: '/tibs.jpg', // Replace with the actual image URL
      },
    {
      id: 6,
      name: 'Dulet || ',
      description: 'The inclusion of organ meats, such as liver, tripe, and spleen, gives Dulet its robust and intense flavor profile. The minced meats are often complemented by the addition of butter or cooking oil, which enhances the richness and succulence of the dish.',
      price: '$9.99',
      image: '/dulet.jpeg', // Replace with the actual image URL
    },
  ];

  return (
    <div className=" py-16">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-semibold underline text-orange-500 text-center mb-8">Our Menu</h1>
        <h2 className="text-2xl font-semibold text-orange-500 text-center mb-8">Main Menu</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="bg-amber-400 rounded-lg p-6 shadow-lg transition-transform transform hover:scale-105"
            >
              <img
                src={item.image}
                alt={item.name}
                className="w-full h-auto object-cover mb-4 rounded"
              />
              <h3 className="text-xl text-center font-semibold mb-2">{item.name}</h3>
              <p className="text-gray-600 text-center mb-4">{item.description}</p>
           
            </div>
          ))}
        </div>
      </div>
      <Vegeterian />
      <Additional />
    </div>
   
  );
};

export default Menu;
